export const FooterData = [
  {
    label: "Online Purchase Support",
    children: [],
  },
  {
    label: "Quick Links",
    children: [],
  },
  {
    label: "Company",
    children: [
      {
        label: "About Us",
        link: "/about-us",
      },
      {
        label: "FAQs",
        link: "/faqs",
      },
      {
        label: "Contact Us",
        link: "/contact-us",
      },
      {
        label: "Inspiration Zones",
        link: "/inspiration-zone-listing",
      },
      {
        label: "Idea Book",
        link: "/idea-book",
      },
      {
        label: "Blogs",
        link: "/blogs",
      },
      {
        label: "Catalogues",
        link: "/catalogue",
      },
      {
        label: "Bulk Enquiry",
        link: "/bulk-enquiry",
      },
      {
        label: "News & Media",
        link: "/news",
      },
    ],
  },
  {
    label: "Policy Information",
    children: [
      {
        label: "Replacement & Cancellation",
        link: "/replacement-and-cancellation",
      },
      {
        label: "Warranty",
        link: "/warranty",
      },
      {
        label: "Shipping and Tracking",
        link: "/shipping-and-tracking",
      },
      {
        label: "Privacy Policy",
        link: "/privacy-policy",
      },
      {
        label: "Terms of Use",
        link: "/terms-of-use",
      },
      // {
      //   label: "Buying Guide",
      //   link: "/buying-guide",
      // },
    ],
  },
];
